import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import { useLanguage } from "../LanguageContext";

const deadlines = {
    en: [
      { title: "Abstract", date: "CLOSED (2025 February, 20)" },
      { title: "Peer review", date: "CLOSED (2025 February, 28)" },
      { title: "Contributions", date: "CLOSED (2025 July, 30)" },
      { title: "Publication", date: "CLOSED (2025 September, 30)" },
    ],
    hu: [
      { title: "Absztrakt", date: "LEZÁRULT (2025. Február 20.)" },
      { title: "Bírálat", date: "LEZÁRULT (2025. Február 28.)" },
      { title: "Hozzájárulások", date: "LEZÁRULT (2025. Július 30.)" },
      { title: "Publikáció", date: "LEZÁRULT (2025. Szeptember 30.)" },
    ],
  };

export default function Deadlines() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f4f4f4",
        padding: "30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
      {/* Page Title */}
      <Typography
        variant="h3"
        sx={{
          marginBottom: "30px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#cc0000",
        }}>
        {language === "en" ? "Conference Deadlines" : "Konferencia határidők"}
      </Typography>

      {/* Deadlines List */}
      <List
        sx={{
          width: "100%",
          maxWidth: "600px",
          backgroundColor: "white",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
          borderRadius: "10px",
          padding: "20px",
        }}>
        {deadlines[language].map((deadline, index) => (
          <ListItem
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: index !== deadlines[language].length - 1 ? "1px solid #ddd" : "none",
              padding: "10px 0",
            }}>
            <ListItemText
              primary={deadline.title}
              primaryTypographyProps={{
                variant: "h6",
                fontWeight: "bold",
                textAlign: "justify",
                fontSize: "18px",
              }}/>
            <Typography
              variant="body1"
              sx={{
                color: "#555",
                fontSize: "16px",
                textAlign: "justify",
              }}>
              {deadline.date}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
